<div class="informative-pebble-icon-wrapper">
    <vpg-pebble-icon
        [id]="'informative-icon-pebble'"
        [icon]="icon || ''"
        [image]="imageUrl || '' | assetUrl"
        [color]="pebbleIconColor"
        [backgroundColor]="pebbleBackgroundColor"
        aria-hidden="true"
        [class]="hideImageOnSmallScreen ? 'hide-on-small-screen' : ''"></vpg-pebble-icon>
    <div class="bn-display-flex-column">
        <ng-content></ng-content>
    </div>
</div>
